import React from "react";
import { Typography } from "antd";
import DefaultParagraph from "./components/DefaultParagraph";
import {
  //Bold,
  DefaultTitle,
} from "./components/ParagraphElement";
const { Title } = Typography;

const PrivacyPolicesThai = () => {
  return (
    <div
      style={{
        margin: "20px auto",
        padding: 10,
      }}
    >
      <Title level={3} style={{ textAlign: "center" }}>
        นโยบายการคุ้มครองข้อมูลส่วนบุคคล
      </Title>
      <div className="w-max m-auto mb-6">
        <DefaultTitle>1. ข้อมูลส่วนบุคคลที่มีการเก็บรวบรวม </DefaultTitle>
        <DefaultParagraph>
          โดยทั่วไปแล้ว ในการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อรุณ พลัส
          จะเก็บรวบรวมข้อมูลส่วนบุคคลโดยการขอหรือสอบถามข้อมูลเหล่านั้นจากท่านเองผ่านทางการลงทะเบียนใช้งานและการใช้งานแอพพลิเคชั่น
          หรือรับข้อมูลจากการติดต่อสอบถาม เสนอแนะและร้องเรียนผ่าน Call Center
          หรือระบบร้องเรียนผ่านแอพพลิเคชั่น
        </DefaultParagraph>
        <DefaultParagraph>
          ทั้งนี้ อรุณ พลัส ดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน
          ดังต่อไปนี้
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 20px", maxWidth: 780 }}
        >
          ข้อมูลส่วนบุคคลทั่วไป
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 780 }}
        >
          (1) ข้อมูลที่ใช้ระบุตัวตน (Identity Data) เช่น ชื่อ นามสกุล
          วันเดือนปีเกิด เพศ อายุ เป็นต้น
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 780 }}
        >
          (2) ข้อมูลติดต่อ (Contact Data) เช่น ที่อยู่ เบอร์โทรศัพท์ อีเมล
          ผู้ติดต่อได้ในกรณีฉุกเฉิน LINE ID เป็นต้น
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 760 }}
        >
          (3) ข้อมูลมิเตอร์ไฟฟ้า เช่น บัญชีสัญญา รหัสเครื่องวัดฯ เป็นต้น
          ที่จำเป็นสำหรับติดต่อการไฟฟ้านครหลวงเพื่อขอสายเมนวงจรที่สอง สำหรับ EV
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 780 }}
        >
          (4) ประวัติการใช้งาน เช่น สถานีที่ใช้บริการ เวลาที่เข้ารับบริการ
          ปริมาณไฟฟ้าที่ได้ใช้งาน เป้นต้น
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "auto auto 1em 30px", maxWidth: 780 }}
        >
          (5) ความคิดเห็น ข้อเสนอแนะ ข้อร้องเรียน
        </DefaultParagraph>

        <DefaultTitle>2. วัตถุประสงค์การใช้และการประมวลผลข้อมูล </DefaultTitle>
        <DefaultParagraph leader="2.1">
          เพื่อประโยชน์ในการประเมิน ปรับปรุง และพัฒนาผลิตภัณฑ์ การให้บริการ
          และการดำเนินงานของ ARUN PLUS
          และเพื่อการร่วมกิจกรรมและรายการส่งเสริมการขายต่าง ๆ ของ ARUN PLUS
        </DefaultParagraph>
        <DefaultParagraph leader="2.2">
          เพื่อวิเคราะห์ วิจัย และพัฒนาผลิตภัณฑ์ และบริการของ ARUN PLUS
          ให้เหมาะสมกับความต้องการของผู้ใช้
        </DefaultParagraph>
        <DefaultParagraph leader="2.3">
          เพื่อแจ้งข้อมูลข่าวสารเกี่ยวกับผลิตภัณฑ์หรือบริการของ ARUN PLUS
          กิจกรรมทางการตลาด รายการส่งเสริมการขายต่างๆ แคมเปญ สิทธิประโยชน์
          การเชิญชวนเข้าร่วมกิจกรรมหรือโครงการ
          และการนำเสนอผลิตภัณฑ์หรือบริการต่างๆ ของ ARUN PLUS ผ่านทาง
          ไปรษณีย์อิเล็กทรอนิกส์ โทรศัพท์ ข้อความ SMS ทางโทรศัพท์มือถือ
        </DefaultParagraph>
        <DefaultParagraph leader="2.4">
          เพื่อวัตถุประสงค์ในการดำเนินธุรกิจ
          ประกอบการเบิกจ่ายและปิดค่าใช้จ่ายที่เกี่ยวข้องกับหน่วยงานบัญชีการเงิน
          และการบริหารงานภายใน
        </DefaultParagraph>
        <DefaultParagraph leader="2.5">
          เพื่อติดต่อการไฟฟ้านครหลวงเพื่อขอสายเมนวงจรที่สอง สำหรับ EV Charger
          สำหรับที่พักอาศัย
        </DefaultParagraph>

        <DefaultTitle>3. ระยะเวลาในการเก็บรวบรวมข้อมูลส่วนบุคคล</DefaultTitle>
        <DefaultParagraph>
          อรุณ พลัส
          จะเก็บรักษาข้อมูลส่วนบุคคลของท่านเป็นระยะเวลาเท่าที่จำเป็นเพื่อวัตถุประสงค์ในการเก็บรวบรวมใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลซึ่งได้ระบุไว้ในแบบแจ้งฉบับนี้
          หลักเกณฑ์ที่ใช้กำหนดระยะเวลาเก็บ ได้แก่ ระยะเวลาที่ อรุณ พลัส
          ยังคงจำเป็นต้องใช้ประโยชน์จากข้อมูลส่วนบุคคลของท่านตามวัตถุประสงค์
          และอาจเก็บต่อไปตามระยะเวลาที่จำเป็นเพื่อการปฏิบัติตามกฎหมายหรือตามอายุความทางกฎหมาย
          เพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย
          การปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย
          หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย
          หรือเพื่อเหตุอื่นตามนโยบายและข้อกำหนดภายในองค์กรของ อรุณ พลัส
        </DefaultParagraph>

        <DefaultTitle>4. การเปิดเผยข้อมูล</DefaultTitle>
        <DefaultParagraph>
          ในการดำเนินการตามวัตถุประสงค์ที่ระบุไว้ในหนังสือแจ้งฉบับนี้ อรุณ พลัส
          อาจเปิดเผยข้อมูลของท่านให้แก่บุคคลภายนอกดังต่อไปนี้
        </DefaultParagraph>
        <DefaultParagraph leader="4.1">
          บริษัทในกลุ่ม อรุณ พลัส
        </DefaultParagraph>
        <DefaultParagraph leader="4.2">
          หน่วยงานราชการ หน่วยงานกำกับดูแล หรือหน่วยงานอื่นตามที่กฎหมายกำหนด
          รวมถึงเจ้าพนักงานซึ่งใช้อำนาจตาม กฎหมาย เช่น ศาล ตำรวจ เป็นต้น
        </DefaultParagraph>
        <DefaultParagraph leader="4.3">
          ตัวแทน ผู้รับจ้าง/ผู้รับจ้างช่วง
          และ/หรือผู้ให้บริการสำหรับการดำเนินงานใด ๆ ให้แก่ อรุณ พลัส เช่น
          ผู้ให้บริการขนส่ง บริษัท รับจ้างทำกิจกรรมทางการตลาด
          บริษัทรับจ้างจัดหาที่พักและการเดินทาง บริษัทรับดำเนินการจัดกิจกรรม
          งานอบรม หรืองานสัมมนา ผู้รับจ้างจัดกิจกรรม ผู้รับจ้างผลิตสื่อ
          ผู้รับจ้างประชาสัมพันธ์ ผู้รับประกันภัย
          ผู้ที่มีสิทธิในสถานที่ติดตั้งเครื่องอัดประจุ เป็นต้น
        </DefaultParagraph>
        <DefaultParagraph leader="4.4">
          สถาบันให้การรับรองมาตรฐานระบบการจัดการ
        </DefaultParagraph>
        <DefaultParagraph leader="4.5">
          พันธมิตรทางธุรกิจของ อรุณ พลัส
          ที่มีสิทธิในสถานที่ติดตั้งเครื่องอัดประจุเพื่อให้บริการ
        </DefaultParagraph>
        <DefaultParagraph leader="4.6">ผู้ถือหุ้น</DefaultParagraph>
        <DefaultParagraph leader="4.7">ธนาคาร</DefaultParagraph>
        <DefaultParagraph leader="4.8">
          ผู้รับโอนสิทธิหน้าที่และประโยชน์ใด ๆ จาก อรุณ พลัส
          รวมถึงผู้ที่ได้รับมอบหมายจากผู้รับโอนดังกล่าวให้ดำเนินการแทน
          เช่นกรณีปรับโครงสร้าง การควบรวมกิจการ การแยก หรือ การโอนกิจการ เป็นต้น
        </DefaultParagraph>

        <DefaultTitle>5. สิทธิของท่านในฐานะเจ้าของข้อมูล </DefaultTitle>
        <DefaultParagraph>
          ในฐานะที่ท่านเป็นเจ้าของข้อมูลส่วนบุคคล ท่านสามารถขอใช้สิทธิต่าง ๆ
          ของท่านได้ตามช่องทางที่ อรุณ พลัส กำหนดในข้อ 7. ซึ่งสิทธิต่าง ๆ
          ของท่านมีรายละเอียด ดังนี้
        </DefaultParagraph>
        <DefaultParagraph leader="5.1">
          สิทธิในการเพิกถอนความยินยอม (Right to Withdraw Consent)
        </DefaultParagraph>
        <DefaultParagraph leader="5.1" hideleader>
          ในกรณีที่ อรุณ พลัส ขอความยินยอมจากท่าน
          ท่านมีสิทธิในการเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมกับ
          อรุณ พลัส ได้
          เว้นแต่การเพิกถอนความยินยอมจะมีข้อจำกัดโดยกฎหมายหรือสัญญาที่ให้ประโยชน์แก่ท่าน
        </DefaultParagraph>
        <DefaultParagraph leader="5.1" hideleader>
          ทั้งนี้
          การเพิกถอนความยินยอมจะไม่ส่งผลกระทบต่อการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมไปแล้วโดยชอบด้วยกฎหมาย
        </DefaultParagraph>
        <DefaultParagraph leader="5.2">
          สิทธิในการขอเข้าถึงข้อมูลส่วนบุคคล (Right to Access)
        </DefaultParagraph>
        <DefaultParagraph leader="5.2" hideleader>
          ท่านมีสิทธิขอเข้าถึงและขอรับสำเนาข้อมูลของท่านซึ่งอยู่ในความรับผิดชอบของ
          อรุณ พลัส รวมถึงขอให้ อรุณ พลัส
          เปิดเผยการได้มาซึ่งข้อมูลดังกล่าวที่ท่านไม่ได้ให้ความยินยอมต่อ อรุณ
          พลัส ได้
        </DefaultParagraph>
        <DefaultParagraph leader="5.3">
          สิทธิในการขอให้ส่งหรือโอนข้อมูลส่วนบุคคล (Data Portability Right)
        </DefaultParagraph>
        <DefaultParagraph leader="5.3" hideleader>
          ท่านมีสิทธิขอให้ อรุณ พลัสโอนข้อมูลส่วนบุคคลของท่านที่ท่านให้ไว้กับ
          อรุณ พลัส ได้ตามที่กฎหมายกำหนด
        </DefaultParagraph>
        <DefaultParagraph leader="5.4">
          สิทธิในการคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล (Right
          to Object)
        </DefaultParagraph>
        <DefaultParagraph leader="5.4" hideleader>
          ท่านมีสิทธิในการคัดค้านการประมวลผลข้อมูลที่เกี่ยวกับท่านสำหรับกรณีการเก็บรวบรวม
          ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลที่เกี่ยวกับตนได้ตามที่กฎหมายกำหนด
        </DefaultParagraph>
        <DefaultParagraph leader="5.5">
          สิทธิในการขอลบข้อมูลส่วนบุคคล (Erasure Right)
        </DefaultParagraph>
        <DefaultParagraph leader="5.5" hideleader>
          ท่านมีสิทธิขอให้ อรุณ พลัส ลบข้อมูลส่วนบุคคลของท่านตามที่กฎหมายกำหนด
          อย่างไรก็ตาม อรุณ พลัส
          อาจเก็บข้อมูลส่วนบุคคลของท่านด้วยระบบอิเล็กทรอนิกส์ซึ่งอาจมีบางระบบที่ไม่สามารถลบข้อมูลได้
          ในกรณีเช่นนั้น อรุณ พลัส
          จะจัดให้มีการทำลายหรือทำให้ข้อมูลดังกล่าวกลายเป็นข้อมูลที่ไม่สามารถระบุตัวตนของท่านได้
        </DefaultParagraph>
        <DefaultParagraph leader="5.6">
          สิทธิในการขอให้ระงับการใช้ข้อมูลส่วนบุคคล (Right to Restrict
          Processing)
        </DefaultParagraph>
        <DefaultParagraph leader="5.6" hideleader>
          ท่านมีสิทธิขอให้ อรุณ พลัส
          ระงับการใช้ข้อมูลของท่านได้ตามที่กฎหมายกำหนด
        </DefaultParagraph>
        <DefaultParagraph leader="5.7">
          สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง (Rectification Right)
        </DefaultParagraph>
        <DefaultParagraph leader="5.7" hideleader>
          กรณีที่ท่านเห็นว่าข้อมูลที่ อรุณ พลัส
          มีอยู่นั้นไม่ถูกต้องหรือท่านมีการเปลี่ยนแปลงข้อมูลส่วนบุคคลของท่านเอง
          ท่านมีสิทธิขอให้ อรุณ พลัส
          แก้ไขข้อมูลส่วนบุคคลของท่านเพื่อให้ข้อมูลส่วนบุคคลดังกล่าวถูกต้อง
          เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
        </DefaultParagraph>
        <DefaultParagraph leader="5.8">
          สิทธิในการร้องเรียน (Right to Lodge a Complaint)
        </DefaultParagraph>

        <DefaultTitle>6. การแก้ไขเปลี่ยนแปลงแบบแจ้งฉบับนี้ </DefaultTitle>
        <DefaultParagraph>
          เราอาจแก้ไขปรับปรุงแบบแจ้งเกี่ยวกับข้อมูลส่วนบุคคลฉบับนี้เป็นครั้งคราว
          และเมื่อมีการแก้ไขเปลี่ยนแปลงเช่นว่านั้น เราจะประกาศให้ท่านทราบผ่านทาง
          แอพพลิเคชั่น และ/หรือแจ้งให้ท่านทราบผ่านทางอีเมล ทั้งนี้
          หากจำเป็นต้องขอความยินยอมจากท่านเราจะดำเนินการขอความยินยอมจากท่านเพิ่มเติมด้วย
        </DefaultParagraph>

        <DefaultTitle>7. วิธีการติดต่อ </DefaultTitle>
        <DefaultParagraph>
          ในกรณีที่มีข้อสงสัยหรือต้องการสอบถามรายละเอียดเพิ่มเติมเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลของท่าน
          การเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลของท่าน การใช้สิทธิของท่าน
          หรือมีข้อร้องเรียนใด ๆ ท่านสามารถติดต่อ อรุณ พลัส
          ได้ตามช่องทางดังต่อไปนี้
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "0px 0px 0px -12px", maxWidth: 780 }}
        >
          บริษัท อรุณ พลัส จำกัด
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "0px 0px 0px -12px", maxWidth: 780 }}
        >
          สถานที่ติดต่อ: 555/1 อาคารเอนเนอร์ยี่คอมเพล็กซ์ อาคาร เอ ชั้น จี
          ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กรุงเทพฯ 10900
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "0px 0px 0px -12px", maxWidth: 780 }}
        >
          เบอร์โทรศัพท์: 02-537-3067
        </DefaultParagraph>
        <DefaultParagraph
          style={{ margin: "0px 0px 0px -12px", maxWidth: 780 }}
        >
          อีเมล: onionevcharger@gmail.com
        </DefaultParagraph>
      </div>
    </div>
  );
};

export default PrivacyPolicesThai;
